import Vue from 'vue';
import VueRouter from 'vue-router';
import { login } from '@/services/apis';
import { onGASetUserId } from '@/utils/GATag';

Vue.use(VueRouter);

export const routes = [
  {
    path: '/',
    nmae: 'Home',
    component: () => import('@/views/Home'),
  },
  {
    path: '/claim-combination',
    name: 'ClaimCombination',
    component: () => import('@/views/ClaimCombination'),
  },
  {
    path: '/claim-combination-result-print',
    name: 'ClaimCombinationResultPrint',
    component: () => import('@/views/ClaimCombinationResultPrint'),
  },
  {
    path: '/auth/callback',
    name: 'Auth',
    component: () => import('@/views/Auth'),
  },
  {
    path: '/login',
    name: 'Login',
    beforeEnter: to => {
      const { refer } = to.query;
      login(refer);
    },
  },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  const accessToken = JSON.parse(localStorage.getItem('accessToken'));
  if (to.name === 'Login') {
    next();
    return;
  }
  if (to.name === 'Auth') {
    next();
    return;
  }
  if (!accessToken) {
    login();
  } else {
    if (to.name) {
      onGASetUserId(accessToken);
    }
  }
  next();
});
export default router;
